$(function() {

    $('body').on('input', 'input, textarea', function(event) {
        if ($(this).hasClass('has-error')) {
            var form = $(this).parents('form');

            checkFormField($(this));
            if ($(this).attr('type') == 'password') isPasswordsEqual(form, true);
            if ($(this).hasClass('has-error')) showErrorMessage($(this));
            else hideErrorMessage();
        }
    });


    $('body').on('focus', 'input.has-error, textarea.has-error', function(event) {
        showErrorMessage($(this));
    });


    $('body').on('blur', 'input, textarea', function(event) {
        var form = $(this).parents('form'),
            name = $(this).attr('name');

        $(this).addClass('blured');

        checkFormField($(this));
        if ($(this).attr('type') == 'password') isPasswordsEqual(form, true);
        hideErrorMessage();
    });

});


// Показывает сообщение об ошибке для поля jqField
function showErrorMessage(jqField) {
    var height = jqField.outerHeight(),
        width = jqField.outerWidth(),
        form = jqField.parents('form'),
        top = jqField.offset().top - form.offset().top + height + 1,
        left = jqField.offset().left - form.offset().left,
        errorMessage = jqField.data('error-message'),
        hintContainer = form.find('.form-error-hint-container');

    if (hintContainer.length == 0) {
        form.append('<div class="form-error-hint-container"><div class="form-error-hint"></div></div>');
        hintContainer = form.find('.form-error-hint-container');
    }

    if (jqField.prop('tagName') == 'INPUT') hintContainer.css('width', width);
    else hintContainer.removeAttr('style');

    hintContainer.addClass('visible').css({
        top: top,
        left: left,
    }).find('.form-error-hint').html(errorMessage);
}


// Скрывает сообщение об ошибке
function hideErrorMessage() {
    $('.form-error-hint-container').removeAttr('style').removeClass('visible');
}


// Проверяет отдельное поле формы
function checkFormField(jqField, onlyCheck) {
    var onlyCheck = onlyCheck ? onlyCheck : false,
        form = jqField.parents('form'),
        tagName = jqField.prop('tagName'),
        inputType = (tagName == 'INPUT') ? jqField.attr('type') : undefined,
        name = jqField.attr('name'),
        val = jqField.val(),
        regExp = new RegExp(),
        errorMessage = false;

    if (tagName == 'INPUT') {
        if (inputType == 'text') {
            if ((~name.indexOf('name') || ~name.indexOf('patronymic')) && !~name.indexOf('username')) {
                if (jqField.hasClass('required')) regExp = /^[-–—а-яё\s]+$/i;
                else regExp = /(^[-–—а-яё\s]*$)|(^$)/i;
                errorMessage = 'Можно использовать только буквы русского алфавита или дефис';
            }
            else if (~name.indexOf('confirm_code')) {
                if (jqField.hasClass('required')) regExp = /^\d{4}$/;
                else regExp = /(^\d{4}$)|(^$)/;
                errorMessage = 'Код указан неверно, введите 4 цифры';
            }
            else if (~name.indexOf('date_start')) {
                if (jqField.hasClass('required')) regExp = /^\d{2}\.\d{2}\.\d{4}$/;
                else regExp = /(^\d{2}\.\d{2}\.\d{4}$)|(^$)/;
                errorMessage = 'Дата начала срока действия абонемента указана неверно';
            }
        }
        else if (inputType == 'email') {
            if (~name.indexOf('email') || ~name.indexOf('username')) {
                if (jqField.hasClass('required')) regExp = /^[-0-9a-zа-яё_\.]+@[-0-9a-zа-яё_\.]+\.[a-zа-яё]{2,6}$/i;
                else regExp = /(^[-0-9a-zа-яё_\.]+@[-0-9a-zа-яё_\.]+\.[a-zа-яё]{2,6}$)|(^$)/i;
                errorMessage = 'Email указан неверно';
            }
        }
        else if (inputType == 'tel') {
            if (~name.indexOf('phone')) {
                if (jqField.hasClass('required')) regExp = /^\+7 \(\d{3}\) \d{3} \d{2} \d{2}$/;
                else regExp = /(^\+7 \(\d{3}\) \d{3} \d{2} \d{2}$)|(^\+7\s$)|(^$)/;
                errorMessage = 'Номер телефона должен быть в федеральном формате (10 цифр)';
            }
        }
        else if (inputType == 'password') {
            if (~name.indexOf('password')) {
                if (jqField.hasClass('required')) {
                    if (jqField.hasClass('strict')) {
                        regExp = [
                            /^[0-9a-z~!?@#$%^&*_\-+()\[\]{}></\\|.,:;]{6,}$/i,
                            /[A-Z]+/,
                            /[a-z]+/,
                            /\d+/,
                            /[~!?@#$%^&*_\-+()\[\]{}></\\|.,:;]*/,
                        ];
                        errorMessage = 'Пароль должен быть не короче шести символов, состоять из букв латинского алфавита, цифр или спецсимволов: ~ ! ? @ # $ % ^ & * _ - + ( ) [ ] { } > < / \\ | . , : ;, а также содержать как минимум одну цифру, одну букву в нижнем и одну букву в верхнем регистрах, например: Paluba2016';
                    }
                    else {
                        regExp = /^.+$/i;
                    }
                }
                else {
                    regExp = /^.*$/i;
                }
            }
        }
        else if (inputType == 'checkbox') {
            if (jqField.hasClass('required') && !jqField.prop('checked')) {
                if (!onlyCheck) $('label[for="' + jqField.attr('id') + '"]').addClass('has-error');
                return false;
            }
        }
    }
    else if (tagName == 'TEXTAREA') {
        if (jqField.hasClass('required')) regExp = /^[\w\W]+$/i;
        else regExp = /^[\w\W]*$/i;
    }

    if (jqField.hasClass('required') && val == '') errorMessage = 'Это поле является обязательным и не может быть пустым';

    if (regExp instanceof RegExp) {
        if (!regExp.test(val)) {
            if (!onlyCheck) jqField.addClass('has-error').data('error-message', errorMessage);
            return false;
        }
        else {
            if (!onlyCheck) jqField.removeClass('has-error').removeAttr('data-error-message');
            return true;
        }
    }
    else if (regExp instanceof Array) {
        var regExpStatus = true;

        $.each(regExp, function(key, value) {
            if (!value.test(val)) regExpStatus = false;
        });

        if (!onlyCheck) {
            if (!regExpStatus) jqField.addClass('has-error').data('error-message', errorMessage);
            else jqField.removeClass('has-error').removeAttr('data-error-message');
        }
        return regExpStatus;
    }
}


// Проверяет значения полей с паролями на соответствие друг другу
function isPasswordsEqual(jqForm, checkOnlyAllBlured) {
    var passwordInputs = jqForm.find('input[type="password"]').filter('input[data-check-password-equal="true"]'),
        passwordValue = passwordInputs.eq(0).val(),
        checkOnlyAllBlured = checkOnlyAllBlured ? checkOnlyAllBlured : false,
        isEqual = true;

    if (passwordInputs.length > 1) {
        passwordInputs.each(function(i) {
            if (checkOnlyAllBlured && !$(this).hasClass('blured')) {
                isEqual = true;
                return false;
            }

            if ($(this).val() != passwordValue) {
                errorMessage = 'Пароли не совпадают';
                isEqual = false;
                return false;
            }
        });

        if (!isEqual) {
            passwordInputs.addClass('has-error').data('error-message', errorMessage);
        }
        else {
            passwordInputs.each(function() {
                if (checkFormField($(this), true)) $(this).removeClass('has-error').removeAttr('data-error-message');
            });
        }
    }

    return isEqual;
}


// Проверяет все поля формы на валидность
function validateFormFields(jqForm) {
    var validateStatus = true;

    jqForm.find('input, textarea').not('[type="hidden"]').each(function() {
        var fieldValidateStatus = checkFormField($(this));

        if (!fieldValidateStatus) validateStatus = fieldValidateStatus;
    });

    if (!isPasswordsEqual(jqForm)) validateStatus = false;

    return validateStatus;
}